module.exports = __webpack_public_path__ + "static/media/alpenwiese.593b29b8.jpg";